import React, { useState } from "react";

import "./css/text_field.scss";
import TrainingTip from "../ui/training_tip";

/**
 * TextField is suitable for rendering a text-input component.
 */
export default function TextField({
  className,
  onChange,
  fieldName,
  naked,
  id,
  title,
  tabIndex,
  readOnly,
  placeholder,
  datalist,
  name,
  value,
  typeOverride,
  onBlur,
  onBlurChange,
  onKeyPress,
  showRequired
}) {
  const [isBlurChanged, setBlurChanged] = useState(false);
  const [reveal, setReveal] = useState(false);
  // Password fields get our own always-present show/hide toggle (the browser's
  // native reveal icon is inconsistent and disappears). Only for password type.
  const isPassword = typeOverride === "password";
  const effectiveType = isPassword ? (reveal ? "text" : "password") : typeOverride || "text";

  function class_name() {
    let classname = "input-field text-field";

    if (className) {
      classname += ` ${className}`;
    }
    return classname;
  }

  function onClick(event) {
    if (!readOnly) {
      event.target.select();
    }
  }

  function change(event) {
    setBlurChanged(true);
    if (onChange && fieldName) {
      onChange({
        [fieldName]: event.target.value
      });
    }
  }

  function onBlurred() {
    if (isBlurChanged && onBlurChange && fieldName) {
      onBlurChange({ [fieldName]: value });
    }
    if (onBlur) {
      onBlur();
    }
    setBlurChanged(false);
  }

  if (naked) {
    return <span className={className}>{value}</span>;
  }

  return (
    <div
      className={
        "input-field-container text-field-container" +
        (isPassword ? " password-field-container" : "")
      }
    >
      <label htmlFor={id}>
        {name}
        {showRequired && <span className="required-asterisk">*</span>}
        {title && (
          <>
            {" "}
            <TrainingTip content={title} />
          </>
        )}
      </label>

      <input
        id={id}
        type={effectiveType}
        value={value || ""}
        onChange={change}
        onBlur={onBlurred}
        step="any"
        tabIndex={tabIndex}
        className={class_name()}
        readOnly={readOnly}
        onClick={onClick}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        list={id && id + "-datalist"}
      />
      {isPassword && (
        <button
          type="button"
          className="password-reveal-toggle"
          onClick={() => setReveal(r => !r)}
          tabIndex={-1}
          aria-label={reveal ? "Hide password" : "Show password"}
          title={reveal ? "Hide password" : "Show password"}
        >
          {reveal ? "🙈" : "👁"}
        </button>
      )}
      {datalist && (
        <datalist id={id + "-datalist"}>
          {datalist.map(value => (
            <option key={value} value={value} />
          ))}
        </datalist>
      )}
    </div>
  );
}
